import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Carousel from "react-material-ui-carousel"
import LoginBanner from './LoginBanner';
import { bizpost } from '../../ajax';
import { Box } from '@mui/material';

const s:any = {
  master: {
    display: 'flex',
    flexDirection: 'column',
    width: 400,
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    borderRadius: '15px 0 0 15px',
  },
  bannerbox:{
    height: '100%',
    width: '100%',
    backgroundImage: 'url(lib/img/bg02.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    borderRadius: '15px 0 0 15px',
  },
  carousel:{
    width: '100%',
    margin: 0,
    padding: 0,
    borderRadius: '15px 0 0 15px',
    overflow: 'hidden',
    '& .CarouselItem': {
      margin: 0,
      padding: 0,
      width: '100%',
    },
    '& .IndicatorContainer': {
      margin: 0,
      padding: '16px 0',
      justifyContent: 'center',
      gap: '8px',
    },
    '& .IndicatorContainer button': {
      margin: '0 4px',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      border: 'none',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        transform: 'scale(1.2)',
      },
      '&.active': {
        backgroundColor: '#FFFFFF',
        width: '24px',
        borderRadius: '5px',
        transform: 'scale(1)',
      },
    },
    '& .NavButton': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      backdropFilter: 'blur(10px)',
      color: '#FFFFFF',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        transform: 'scale(1.1)',
      },
      '&:disabled': {
        opacity: 0.3,
      },
    },
  },
}

class LoginCarousel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
      this.state = {
      next: true,
      value: this.props.value,
      mode: 'banner',
      items: [],
      autoPlay:true,
      animation: 'fade',
      indicators: true,
      timeout: 5000,
      navButtonsAlwaysVisible: false,
      navButtonsAlwaysInvisible: true,
    };
  }

  componentDidMount(){
    this.refresh();
  }

  refresh = async() => {
    try{
      const params = {s:'uicontent',a:'doc',dcc:'BANNER',dvc:'ALL',lgc:'ALL'};
      this.setState({loading:true});
      const response = await bizpost(params);
      console.log('uicontent response ',response);
      if (response.success){
        const {sd:items} = response;
        this.setState({mode:'slider',items});
      }
      else if(response.failure){
        this.setState({mode:'banner'});
      }      
    }
    catch(err){
      this.setState({mode:'banner'});
    }
    finally{
      this.setState({loading:false});
    }
  }

  // handleChange = () => {
  //   // let value = event.target.value;
  //   // this.props.onChange(value);
  //   // this.setState({value});
  // };

  render() {
    const {classes } = this.props;
    const {mode,items} = this.state;
    const {autoPlay,animation,indicators,timeout,navButtonsAlwaysVisible,navButtonsAlwaysInvisible} = this.state;

    return (
      <Box sx={{...s.master}}>
        {(mode==='slider')?
        <Carousel
            sx={{
              ...s.carousel,
              '& .CarouselItem': {
                margin: 0,
                padding: 0,
                width: '100%',
              },
            }}
            autoPlay={autoPlay}
            animation={animation}
            indicators={indicators}
            interval={timeout}
            duration={600}
            navButtonsAlwaysVisible={navButtonsAlwaysVisible}
            navButtonsAlwaysInvisible={navButtonsAlwaysInvisible}
            stopAutoPlayOnHover={true}
            swipe={true}>
          {
            items.map((item:any, index:number) => {
                return <LoginBanner item={item} key={index} />
            })
          }
        </Carousel>
        :
        <Box sx={{...s.bannerbox}}>
            {/* <!-- Left Panel --> */}

        </Box>
      }
      </Box>
    );
  }
}

LoginCarousel.propTypes = {
  classes: PropTypes.object.isRequired,
  //id: PropTypes.string.isRequired,
  //label: PropTypes.string.isRequired,
};

export default LoginCarousel;
